import { showDialog } from "../../../services/HelperService";
import NewChatDlg from "../../../dialogs/NewChatDlg";

/**
 * Opens the lightweight New Chat dialog (UI only).
 * Returns: { subject } | undefined (if cancelled)
 */
export async function OpenNewChatDlg({
    defaultSubject = "",
    primaryBusinessUnitId = null,
    contactId = null,
    contact = null,
    jobId = null,
    job = null,
    channel = "whatsapp",
    contactPoint = null,
    channelConfig = null,
} = {}) {
    return showDialog(
        <NewChatDlg
            defaultSubject={defaultSubject}
            primaryBusinessUnitId={primaryBusinessUnitId}
            initialContactID={contactId ?? contact?.ID ?? null}
            initialJob={job ?? (jobId ? { ID: jobId } : null)}
            initialChannel={channel}
            initialContactPoint={contactPoint}
            channelConfig={channelConfig}
            onDone={(payload) => payload}
        />
    );
}